import { render, staticRenderFns } from "./cloturerBail.vue?vue&type=template&id=906493b0&scoped=true"
import script from "./cloturerBail.vue?vue&type=script&lang=js"
export * from "./cloturerBail.vue?vue&type=script&lang=js"
import style0 from "./cloturerBail.vue?vue&type=style&index=0&id=906493b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906493b0",
  null
  
)

export default component.exports